import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    IonModal,
    IonGrid,
    IonFooter,
    IonRow,
    IonCol,
    IonContent,
    IonHeader, IonPage, IonTitle, IonToolbar,
    IonApp,
    IonIcon,
    IonLabel,
    IonItemDivider,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    setupIonicReact,
    IonButton,
    IonRouterContext,
    IonRouteProps,
    IonCardContent,
    IonLoading,
    IonToast,
    IonCardHeader,
    IonCardTitle,
    IonCard,
    IonFabButton,
    IonInfiniteScroll,
    IonSegment,
    IonCardSubtitle,
    IonSegmentButton,
    IonList,
    IonItem,
    IonText,
    IonFab,
    IonThumbnail,
    IonSearchbar,
    IonBadge,
    IonTextarea,
    IonInfiniteScrollContent,
    IonCheckbox,
    IonMenuToggle,
    IonMenu,
    withIonLifeCycle,
    IonRefresher,
    IonRefresherContent
} from '@ionic/react';

import { cart, albumsOutline, list, arrowUp, funnel, heart, cartSharp, cartOutline, business, barcode, person, podium, closeOutline, search, add, ticketOutline, receiptOutline, personOutline, callOutline, logoWhatsapp, locationOutline, mapOutline, car, colorFill } from 'ionicons/icons';
import { DebounceInput } from 'react-debounce-input';
import './Products.css';
import PosActions from '../../../actions/PosActions';
import Select from 'react-select'
import { getContact, getModeList, getDominio } from '../../../utils/functions';

import {
    queryAllPermisions
} from "../../../data_base_local/dataservice";
import { baseurl } from '../../../constants/constants';
import { Capacitor } from '@capacitor/core';

interface IProps {

    get_: any;
    addshoppingcart: any;
    setData_: any;
    removedshoppingcartall: any;
}
interface IState {
    categorie_id: any;
    sub_categorie_id: any;

    products: any;
    pageSize: any;
    pages: any;
    current_count_data: any;
    total_rows: any;
    searchText: any;
    price_group: any;
    contact: any;
    data_default: any;
    mode_list: any;
    dominio: any;
    data_module: any;

    pos_location_id: any;
    cash_register_util: any;
}

const options2 = { style: 'currency', currency: 'USD', useGrouping: false };
const _numberFormat = new Intl.NumberFormat('en-US', options2);

class Products extends React.Component<IProps, IState> {
    ionInfiniteScrollRefData: React.RefObject<HTMLIonInfiniteScrollElement>;
    contentRef: React.RefObject<HTMLIonContentElement>;
    constructor(props: any) {
        super(props)
        this.contentRef = React.createRef<HTMLIonContentElement>();
        this.ionInfiniteScrollRefData = React.createRef<HTMLIonInfiniteScrollElement>();
        this.state = {
            sub_categorie_id: props.sub_categorie_id,
            categorie_id: props.categorie_id,
            current_count_data: props.current_count_data,
            products: props.products,
            pageSize: props.pageSize,
            pages: props.pages,
            total_rows: props.total_rows,
            searchText: props.searchText,
            price_group: props.price_group,
            contact: props.contact,
            data_default: props.data_default,
            mode_list: props.mode_list,
            dominio: props.dominio,
            data_module: props.data_module,
            pos_location_id: props.pos_location_id,
            cash_register_util: props.cash_register_util,
        };
    }


    ionViewWillEnter() {
        //this.setState({ dominio: getDominio() });
        this.componentDidMount();
    }

    async componentDidMount() {
        if (Capacitor.isNativePlatform()) {
            //this.ValidatePermission();
        }

        let mode_list = getModeList();
        let contact = getContact();

        this.setState({
            dominio: getDominio(),
            pages: 0,
            pageSize: 10,
            total_rows: 0,
            searchText: '',
            current_count_data: 0,
            contact: contact,
            mode_list: mode_list,
            price_group: contact && contact.selling_price_group_id ? contact.selling_price_group_id : null,

        });
        setTimeout(this.getDataPaginInit.bind(this), 1000);

    }

    /*necesario para validar permisos*/
    async ValidatePermission() {

        let dataPermissions: any = await queryAllPermisions().then();
        let is_valid = true;
        if (dataPermissions && dataPermissions.values.length > 0) {
            dataPermissions.values.map((val: any, key: any) => {
                if (val.status !== 'active') {
                    is_valid = false;
                }
            });
        } else {
            is_valid = false;
        }

        if (!is_valid) {
            window.location.href = baseurl() + "/home";
        }
    };
    /* fin necesario para validar permisos*/

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            products: nextProps.data.data_pagin_products && nextProps.data.data_pagin_products ? nextProps.data.data_pagin_products : [],
            pages: nextProps.data.products && nextProps.data.products.pages ? nextProps.data.products.pages : 0,
            total_rows: nextProps.data.products && nextProps.data.products.total_rows ? nextProps.data.products.total_rows : 0,
            current_count_data: nextProps.data.data_pagin_products ? nextProps.data.data_pagin_products.length : 0,
            data_default: nextProps.data.data_default,
            data_module: nextProps.data.data_module && nextProps.data.data_module ? nextProps.data.data_module : {},
            pos_location_id: nextProps.data.pos_location_id ? nextProps.data.pos_location_id :
                nextProps.data.data_default && nextProps.data.data_default.cash_register_util && nextProps.data.data_default.cash_register_util.current_register ?
                    nextProps.data.data_default.cash_register_util.current_register.location_id : null,
            cash_register_util: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util : null,

        });

        if (this.ionInfiniteScrollRefData.current) {
            if (nextProps.data.concat_list) {
                this.ionInfiniteScrollRefData.current.complete();
            }
        }
        if (nextProps.data.view_active == "dashboard_pos/products") {

            if (nextProps.data.refresh_list) {
                this.setState({
                    pages: 0,
                    pageSize: 10,
                });

                setTimeout(this.getDataPaginInit.bind(this), 1000);
            }

        }

    }

    setSearchText(e: any) {
        const value = e.target.value;
        this.setState({
            searchText: value.toLowerCase(),
            pages: 0,
            pageSize: 10,

        });

        setTimeout(this.getDataPaginInit.bind(this), 1000);
    }

    closemodalClientActions(row: any, index: any) {
        let products = this.state.products;

        const newArr = products.map((item: any, i: any) => {
            if ((index) == i) {
                return {
                    ...item,
                    'modalOpen': false
                };
            } else {
                return item;
            }
        });

        this.setState({
            products: newArr
        });
    }

    setActionClientModalShow(row: any, index: any) {
        let products = this.state.products;

        const newArr = products.map((item: any, i: any) => {
            if ((index) == i) {
                return {
                    ...item,
                    'modalOpen': true
                };
            } else {
                return item;
            }
        });

        this.setState({
            products: newArr
        });
    }

    handleFocus(event: any) {
        event.target.select();
    }

    onChangeForValuesDetailsArrayProductFilter(index: any, e: any) {
        let products = this.state.products;
        let new_productss: any = [];

        if (e.target.name == 'quantity') {
            const newArr = products.map((item: any, i: any) => {
                let current_price = item.current_price;

                //3.precio mayorista
                /*let filter_price_array_units = item.sub_units.filter((item_filter: any) => item_filter.id == item.unit_id);
                if (filter_price_array_units.length > 0) {
                    if (parseFloat(item.factor) != 0 && (parseFloat(e.target.value) * parseFloat(filter_price_array_units[0].multiplier)) >= parseFloat(item.factor)) {
                        let filter_price_array_units_mayoristic = filter_price_array_units[0].price_groups_all.filter((item_filter: any) => item_filter.price_group_id == data_velues.selling_price_may_id);

                        if (filter_price_array_units_mayoristic.length > 0) {
                            current_price = parseFloat(filter_price_array_units[0].multiplier) * parseFloat(filter_price_array_units_mayoristic[0].price_inc_tax);
                        } else {
                            current_price = parseFloat(filter_price_array_units[0].multiplier) * parseFloat(filter_price_array_units[0]._price_group);
                        }
                    } else {
                        if (item.variation_group_price) {
                            current_price = parseFloat(item.variation_group_price);
                        } else {
                            current_price = parseFloat(item.default_sell_price);
                        }
                        let _price_group = parseFloat(filter_price_array_units[0]._price_group) == 0 ? current_price : parseFloat(filter_price_array_units[0]._price_group);
                        current_price = parseFloat(filter_price_array_units[0].multiplier) * parseFloat(_price_group);
                    }
                }*/

                //validar precio con el descuento
                let discount_amount = item.discount_amount;
                let type = item.discount_type;
                let current_price_discount = item.current_price_discount;

                if (type == 'fixed') {
                    current_price_discount = (current_price - discount_amount);
                } else {
                    current_price_discount = current_price - (current_price * (discount_amount / 100));
                }

                if ((index) == i) {
                    return {
                        ...item,
                        [e.target.name]: e.target.value,
                        ['current_price']: current_price,
                        ['current_price_discount']: current_price_discount,
                    };
                } else {
                    return item;
                }
            });
            new_productss = newArr;
        } else if (e.target.name == 'unit_id') {

            const newArr = products.map((item: any, i: any) => {
                let current_price = item.current_price;

                //2. si cambia la unidad de medida cambiar a precio select.
                /*let filter_price_array_units = item.sub_units.filter((item_filter: any) => item_filter.id == e.target.value);
           
                if (filter_price_array_units.length > 0) {
                    if (parseFloat(item.factor) != 0 && (parseFloat(item.quantity) * parseFloat(filter_price_array_units[0].multiplier)) >= parseFloat(item.factor)) {
                        let filter_price_array_units_mayoristic = filter_price_array_units[0].price_groups_all.filter((item_filter: any) => item_filter.price_group_id == data_velues.selling_price_may_id);

                        if (filter_price_array_units_mayoristic.length > 0) {
                            current_price = parseFloat(filter_price_array_units[0].multiplier) * parseFloat(filter_price_array_units_mayoristic[0].price_inc_tax);
                        } else {
                            current_price = parseFloat(filter_price_array_units[0].multiplier) * parseFloat(filter_price_array_units[0]._price_group);
                        }
                    } else {
                        //2.1 validar si la unidad de medida tiene algun precio vinculado para usarlo.
                        if (filter_price_array_units[0]._price != 0) {
                            //2.3 si existe precio por unidad de medida se usa.
                            current_price = parseFloat(filter_price_array_units[0].multiplier) * parseFloat(filter_price_array_units[0]._price_group);
                        } else {
                            //2.4 como no existe precio vinculado a la unidad de medida se elije priorisando precio por grupo de precio sino precio default del producto.
                            if (item.variation_group_price) {
                                current_price = parseFloat(filter_price_array_units[0].multiplier) * parseFloat(item.variation_group_price);
                            } else {
                                current_price = parseFloat(filter_price_array_units[0].multiplier) * parseFloat(item.default_sell_price);
                            }
                        }
                    }
                }*/

                //validar precio con el descuento
                let discount_amount = item.discount_amount;
                let type = item.discount_type;
                let current_price_discount = item.current_price_discount;

                if (type == 'fixed') {
                    current_price_discount = (current_price - discount_amount);
                } else {
                    current_price_discount = current_price - (current_price * (discount_amount / 100));
                }

                if ((index) == i) {
                    return {
                        ...item,
                        [e.target.name]: e.target.value,
                        ['current_price']: current_price,
                        ['current_price_discount']: current_price_discount,

                    };
                } else {
                    return item;
                }
            });
            new_productss = newArr;


        } else if (e.target.name == 'discount_type') {
            let type = e.target.value;

            //otros campos no especiales
            const newArr = products.map((item: any, i: any) => {
                let current_price = item.current_price;
                let current_price_discount = item.current_price_discount;

                if (type == 'fixed') {
                    current_price_discount = (current_price - item.discount_amount);
                } else {
                    current_price_discount = current_price - (current_price * (item.discount_amount / 100));
                }
                if ((index) == i) {
                    return {
                        ...item,
                        [e.target.name]: e.target.value,
                        ['current_price_discount']: current_price_discount,
                    };
                } else {
                    return item;
                }
            });
            new_productss = newArr;

        } else if (e.target.name == 'discount_amount') {
            let discount_amount = e.target.value;

            //otros campos no especiales
            const newArr = products.map((item: any, i: any) => {
                let type = item.discount_type;

                let current_price = item.current_price;
                let current_price_discount = item.current_price_discount;

                if (type == 'fixed') {
                    current_price_discount = (current_price - discount_amount);
                } else {
                    current_price_discount = current_price - (current_price * (discount_amount / 100));
                }

                if ((index) == i) {
                    return {
                        ...item,
                        [e.target.name]: e.target.value,
                        ['current_price_discount']: current_price_discount,
                    };
                } else {
                    return item;
                }
            });
            new_productss = newArr;

        } else if (e.target.name == 'current_price') {

            //otros campos no especiales
            const newArr = products.map((item: any, i: any) => {
                let type = item.discount_type;

                let current_price = e.target.value;
                let current_price_discount = item.current_price_discount;

                if (type == 'fixed') {
                    current_price_discount = (current_price - item.discount_amount);
                } else {
                    current_price_discount = current_price - (current_price * (item.discount_amount / 100));
                }

                if ((index) == i) {
                    return {
                        ...item,
                        [e.target.name]: e.target.value,
                        ['current_price_discount']: current_price_discount,
                    };
                } else {
                    return item;
                }
            });
            new_productss = newArr;

        } else if (e.target.name == 'product_group_prices') {

            console.log(e.target.value);
            //otros campos no especiales
            const newArr = products.map((item: any, i: any) => {

                if ((index) == i) {
                    let current_price = item.current_price;
                    let data_price_group = item.data_price_group.filter((item_filter: any) => item_filter.id == e.target.value);
                    if (data_price_group.length > 0) {
                        current_price = data_price_group[0].price_inc_tax;
                    }

                    let current_price_discount = item.current_price;
                    let type = item.discount_type;
                    if (type == 'fixed') {
                        current_price_discount = (current_price - item.discount_amount);
                    } else {
                        current_price_discount = current_price - (current_price * (item.discount_amount / 100));
                    }
                    current_price = current_price_discount;
                    return {
                        ...item,
                        [e.target.name]: e.target.value,
                        ['current_price']: current_price,
                        ['current_price_discount']: current_price_discount,
                    };
                } else {
                    return item;
                }
            });
            new_productss = newArr;
        } else {
            //otros campos no especiales
            const newArr = products.map((item: any, i: any) => {
                if ((index) == i) {
                    return {
                        ...item,
                        [e.target.name]: e.target.value,
                    };
                } else {
                    return item;
                }
            });
            new_productss = newArr;

        }
        this.setState({
            products: new_productss
        });
    }

    /*aqui paginacion funciones default*/
    getDataPaginInit() {
        if (this.state.total_rows != 0 && this.state.current_count_data == this.state.total_rows && this.state.pages != 0) {
            if (this.ionInfiniteScrollRefData.current) {
                this.ionInfiniteScrollRefData.current.complete();
            }
            return;
        }
        this.props.get_({
            typeOption: 'get_catalogo_products',
            search: this.state.searchText,
            pageSize: this.state.pageSize,
            pages: this.state.pages,
            current_count_data: this.state.current_count_data,
            sub_categorie_id: this.state.sub_categorie_id,
            categorie_id: this.state.categorie_id,
            price_group: this.state.price_group,
            pos_location_id: this.state.pos_location_id,
            view_active: 'dashboard_pos/Products'
        }, "api/get_catalogo_products");

    }

    errorimg(e: any, row: any) {
        e.target.src = 'assets/img/default.jpg';
    }

    render_products(row: any, key: any) {
        return (
            <IonCol col-6 size='6' key={"PC-" + key}>
                <IonCard color={'light'}>
                    <img onError={e => this.errorimg(e, row)} src={this.state.dominio + 'uploads/img/' + row.product_image} style={{ marginTop: '-40px' }} />
                    <IonCardContent style={{ padding: '5px' }}>
                        <label className='text-sm font-medium text-g60'> {row.name}</label> <br />
                        <label className='text-g50 font-medium text-xs line-hei-150'><IonIcon className='icon-vertical-aling' size='small' icon={barcode} /> {row.sub_sku} <IonBadge color={parseFloat(row.qty_available) > 0 ? "success" : "danger"}>Stock : {_numberFormat.format(row.qty_available).replace("$", "")}</IonBadge></label>
                        {
                            row.variation != 'DUMMY' ? <><br /> <label className='text-g50 font-medium text-xs line-hei-150'><IonIcon className='icon-vertical-aling' size='small' icon={barcode} /> {row.variation}</label></> : null
                        }
                        <IonRow>
                            <IonCol col-6 size='6' style={{ verticalAlign: 'middle', marginTop: '10%', }}>
                                <strong> {_numberFormat.format(parseFloat(row.current_price_discount)).replace("$", "")}</strong>
                            </IonCol>
                            <IonCol col-6 size='6' style={{ textAlign: 'right' }}>
                                <IonButton shape="round" size="small" color={"#f0f1f5"} style={{ width: "35px", height: "35px", fontSize: "10px" }} onClick={() => this.setActionClientModalShow(row, key)}>
                                    <IonIcon slot="icon-only" style={{ color: "#022140" }} icon={cartSharp} />
                                </IonButton>
                            </IonCol>

                        </IonRow>
                        <IonModal onWillDismiss={e => this.closemodalClientActions(row, key)} isOpen={row.modalOpen ?? false} trigger="open-modal" initialBreakpoint={0.80} breakpoints={[0, 0.50, 0.5, 0.75]}>
                            <IonHeader>
                                <IonToolbar>
                                    <IonTitle>{row.name}</IonTitle>
                                    <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={(ev) => this.closemodalClientActions(row, key)}>
                                        <IonIcon icon={closeOutline}></IonIcon>
                                    </IonButton>
                                </IonToolbar>
                            </IonHeader>
                            <IonContent className="ion-padding">
                                <IonRow>
                                    <IonCol col-6 size='6'>
                                        Cantidad <br />
                                        <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input' defaultValue={_numberFormat.format(parseFloat(row.quantity)).replace("$", "")} min="0" onChange={e => this.onChangeForValuesDetailsArrayProductFilter(key, e)} name="quantity" />
                                    </IonCol>
                                    <IonCol col-6 size='6'>
                                        Precio Venta <br />
                                        <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input' value={row.current_price ?? 0} min="0" onChange={e => this.onChangeForValuesDetailsArrayProductFilter(key, e)} name="current_price" />
                                    </IonCol>
                                    <IonCol col-12 size='12'>
                                        Unidad de Medida <br />
                                        {
                                            row.sub_units && row.sub_units.length > 0 ?
                                                <Select
                                                    onChange={(e: any) => this.onChangeForValuesDetailsArrayProductFilter(key, { target: { name: 'unit_id', value: e.value } })}
                                                    placeholder="Sub Categoria"
                                                    name='unit_id'
                                                    menuPortalTarget={document.querySelector('body')}
                                                    isSearchable={false}
                                                    options={
                                                        row && row.sub_units && row.sub_units.map((option: any) => (
                                                            { label: option.name, value: option.id }
                                                        ))
                                                    }
                                                    styles={{
                                                        menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                                    }}
                                                    defaultValue={row.unit_id ?
                                                        row.sub_units && row.sub_units.length > 0 ?
                                                            { label: row.sub_units.filter((item: any) => item.id == row.unit_id)[0].name, value: row.sub_units.filter((item: any) => item.id == row.unit_id)[0].id }
                                                            : null
                                                        : null
                                                    }
                                                /> : null
                                        }
                                    </IonCol>
                                    <IonCol col-12 size='12'>
                                        Grupo de Precio <br />
                                        {
                                            row.data_price_group && row.data_price_group.length > 0 ?
                                                <Select
                                                    onChange={(e: any) => this.onChangeForValuesDetailsArrayProductFilter(key, { target: { name: 'product_group_prices', value: e.value } })}
                                                    placeholder="Grupo de Precio"
                                                    name='product_group_prices'
                                                    menuPortalTarget={document.querySelector('body')}
                                                    isSearchable={false}
                                                    options={
                                                        row && row.data_price_group && row.data_price_group.map((option: any) => (
                                                            { label: option.name ?? '', value: option.id ?? null }
                                                        ))
                                                    }
                                                    styles={{
                                                        menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                                    }}
                                                    defaultValue={row.product_group_prices ?
                                                        row.data_price_group && row.data_price_group.length > 0 ?
                                                            { label: row.data_price_group.filter((item: any) => item.id == row.product_group_prices)[0].name ?? '', value: row.data_price_group.filter((item: any) => item.id == row.product_group_prices)[0].id ?? null }
                                                            : null
                                                        : null
                                                    }
                                                /> : null
                                        }
                                    </IonCol>
                                    <IonCol col-6 size='6'>
                                        Tipo de Descuento <br />
                                        {
                                            <Select
                                                onChange={(e: any) => this.onChangeForValuesDetailsArrayProductFilter(key, { target: { name: 'discount_type', value: e.value } })}
                                                placeholder="Tipo de descuento"
                                                name='discount_type'
                                                menuPortalTarget={document.querySelector('body')}
                                                isSearchable={false}
                                                options={[
                                                    { label: "Fijo", value: 'fixed' },
                                                    { label: "Porcentaje", value: 'percentage' },
                                                ]}
                                                styles={{
                                                    menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                                }}
                                                defaultValue={row.discount_type ?
                                                    row.discount_type == 'fixed' ? { label: "Fijo", value: 'fixed' } : { label: "Porcentaje", value: 'percentage' }
                                                    :
                                                    { label: "Fijo", value: 'fixed' }
                                                }
                                            />
                                        }
                                    </IonCol>
                                    <IonCol col-6 size='6'>
                                        Monto del Descuento <br />
                                        <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input'
                                            defaultValue={_numberFormat.format(parseFloat(row.discount_amount)).replace("$", "")}
                                            min="0" onChange={e => this.onChangeForValuesDetailsArrayProductFilter(key, e)} name="discount_amount" />
                                    </IonCol>
                                    <IonCol col-6 size='6'>
                                        Stock : {_numberFormat.format(row.qty_available).replace("$", "")}
                                    </IonCol>
                                    <IonCol col-6 size='6'>
                                        Sub-Total : {_numberFormat.format(parseFloat(row.current_price_discount) * parseFloat(row.quantity)).replace("$", "")}
                                    </IonCol>
                                    <IonCol col-12 size='12'>
                                        <IonButton
                                            size="default"
                                            color="primary"
                                            expand="full"
                                            shape="round"
                                            onClick={() => this.AddToCar(row)} >
                                            <IonIcon icon={cart}></IonIcon>
                                        </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonContent>
                        </IonModal>
                    </IonCardContent>
                </IonCard>
            </IonCol>
        );
    }

    render_products_list(row: any, key: any) {
        return (
            <IonCol col-12 size='12' key={"PL-" + key}>
                <IonCard style={{ marginInline: "2px", textAlign: 'center' }}>
                    <IonItem>
                        <IonThumbnail slot="start">
                            <img onError={e => this.errorimg(e, row)} style={{ textAlign: 'center', width: "100%" }} src={this.state.dominio + 'uploads/img/' + row.product_image} />
                        </IonThumbnail>
                        <IonCol col-12 size='12' style={{ textAlign: 'left', color: "#808289" }}>
                            <IonRow>
                                <IonCol col-12 size='12' style={{ textAlign: 'left' }} >
                                    <label className='text-sm font-medium text-g60'> {row.name}</label>   <br />
                                    <label className='text-g50 font-medium text-xs line-hei-150'><IonIcon className='icon-vertical-aling' size='small' icon={barcode} /> {row.sub_sku} </label> <IonBadge color={parseFloat(row.qty_available) > 0 ? "success" : "danger"}>Stock : {_numberFormat.format(row.qty_available).replace("$", "")}</IonBadge>
                                    {
                                        row.variation != 'DUMMY' ? <><br /> <label className='text-g50 font-medium text-xs line-hei-150'><IonIcon className='icon-vertical-aling' size='small' icon={barcode} /> {row.variation}</label></> : null
                                    }
                                </IonCol>
                                <IonCol col-8 size='8' style={{ textAlign: 'left' }}>
                                    <strong> {_numberFormat.format(parseFloat(row.current_price_discount)).replace("$", "")}</strong>
                                </IonCol>
                                <IonCol col-4 size='4' style={{ textAlign: 'right' }} >
                                    <IonIcon
                                        style={{
                                            color: "#022140",
                                            fontSize: "25px",
                                            verticalAlign: 'middle'
                                        }}
                                        icon={cartSharp}
                                        onClick={() => this.setActionClientModalShow(row, key)}
                                    />&nbsp;&nbsp;
                                </IonCol>
                            </IonRow>

                        </IonCol>
                    </IonItem>
                    <IonModal onWillDismiss={e => this.closemodalClientActions(row, key)} isOpen={row.modalOpen ?? false} trigger="open-modal" initialBreakpoint={0.50} breakpoints={[0, 0.50, 0.5, 0.75]}>
                        <IonHeader>
                            <IonToolbar>
                                <IonTitle>{row.name}</IonTitle>
                                <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={(ev) => this.closemodalClientActions(row, key)}>
                                    <IonIcon icon={closeOutline}></IonIcon>
                                </IonButton>
                            </IonToolbar>
                        </IonHeader>
                        <IonContent className="ion-padding">
                            <IonRow>
                                <IonCol col-6 size='6'>
                                    Cantidad <br />
                                    <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input' defaultValue={_numberFormat.format(parseFloat(row.quantity)).replace("$", "")} min="0" onChange={e => this.onChangeForValuesDetailsArrayProductFilter(key, e)} name="quantity" />
                                </IonCol>
                                <IonCol col-6 size='6'>
                                    Precio Venta <br />
                                    <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input' value={row.current_price ?? 0} min="0" onChange={e => this.onChangeForValuesDetailsArrayProductFilter(key, e)} name="current_price" />
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    Unidad de Medida <br />
                                    {
                                        row.sub_units && row.sub_units.length > 0 ?
                                            <Select
                                                onChange={(e: any) => this.onChangeForValuesDetailsArrayProductFilter(key, { target: { name: 'unit_id', value: e.value } })}
                                                placeholder="Sub Categoria"
                                                name='unit_id'
                                                menuPortalTarget={document.querySelector('body')}
                                                isSearchable={false}
                                                options={
                                                    row && row.sub_units && row.sub_units.map((option: any) => (
                                                        { label: option.name, value: option.id }
                                                    ))
                                                }
                                                styles={{
                                                    menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                                }}
                                                defaultValue={row.unit_id ?
                                                    row.sub_units && row.sub_units.length > 0 ?
                                                        { label: row.sub_units.filter((item: any) => item.id == row.unit_id)[0].name, value: row.sub_units.filter((item: any) => item.id == row.unit_id)[0].id }
                                                        : null
                                                    : null
                                                }
                                            /> : null
                                    }
                                </IonCol>
                                <IonCol col-6 size='6'>
                                    Tipo de Descuento <br />
                                    {
                                        <Select
                                            onChange={(e: any) => this.onChangeForValuesDetailsArrayProductFilter(key, { target: { name: 'discount_type', value: e.value } })}
                                            placeholder="Tipo de descuento"
                                            name='discount_type'
                                            menuPortalTarget={document.querySelector('body')}
                                            isSearchable={false}
                                            options={[
                                                { label: "Fijo", value: 'fixed' },
                                                { label: "Porcentaje", value: 'percentage' },
                                            ]}
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                            }}
                                            defaultValue={row.discount_type ?
                                                row.discount_type == 'fixed' ? { label: "Fijo", value: 'fixed' } : { label: "Porcentaje", value: 'percentage' }
                                                :
                                                { label: "Fijo", value: 'fixed' }
                                            }
                                        />
                                    }
                                </IonCol>
                                <IonCol col-6 size='6'>
                                    Monto del Descuento <br />
                                    <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input'
                                        defaultValue={_numberFormat.format(parseFloat(row.discount_amount)).replace("$", "")}
                                        min="0" onChange={e => this.onChangeForValuesDetailsArrayProductFilter(key, e)} name="discount_amount" />
                                </IonCol>
                                <IonCol col-6 size='6'>
                                    Stock : {_numberFormat.format(row.qty_available).replace("$", "")}
                                </IonCol>
                                <IonCol col-6 size='6'>
                                    Sub-Total : {_numberFormat.format(parseFloat(row.current_price_discount) * parseFloat(row.quantity)).replace("$", "")}
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <IonButton color="primary" expand="full" shape="round" onClick={() => this.AddToCar(row)} >
                                        <IonIcon icon={cart}></IonIcon>
                                    </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonContent>
                    </IonModal>
                </IonCard>
            </IonCol>
        );
    }

    /*fin paginacion funciones default*/
    render_categories(row: any, key: any) {
        let sub_categories = [];
        if (row.sub_categories && row.sub_categories.length > 0) {
            sub_categories = row.sub_categories.filter((item_filter: any) => item_filter.parent_id == row.id);
        }

        let render = sub_categories.map((val_: any, key_: any) => {
            return (
                <>
                    <IonCol col-2 size='2' key={"DV-" + key_}>
                    </IonCol>
                    <IonCol col-10 size='10' key={"SC-" + key_}>
                        <label htmlFor="">{val_.name}</label>&nbsp;
                        <IonCheckbox
                            onIonChange={e => this.changeDataState({ target: { name: 'sub_categorie_id', value: val_.id } })}
                            checked={this.state.sub_categorie_id == val_.id ? true : false}
                            labelPlacement="stacked"
                            alignment="start">
                        </IonCheckbox>
                    </IonCol>
                </>
            )
        });

        return (
            <>
                <IonCol col-12 size='12' key={"CT-" + key}>
                    <label htmlFor="">{row.name}</label>&nbsp;
                    <IonCheckbox
                        onIonChange={e => this.changeDataState({ target: { name: 'categorie_id', value: row.id } })}
                        checked={this.state.categorie_id == row.id ? true : false}
                        labelPlacement="stacked"
                        alignment="start">
                    </IonCheckbox>
                    <IonRow>
                        {render}
                    </IonRow>
                </IonCol>
                <IonItemDivider></IonItemDivider>
            </>
        );
    }

    changeDataState(e: any) {
        if (e.target.name == "sub_categorie_id") {
            let categorie_id = null;
            if (this.state.data_default && this.state.data_default.categories) {
                this.state.data_default.categories.map((val: any, key: any) => {
                    if (val.sub_categories && val.sub_categories.length > 0) {
                        let filter_sub_categorie = val.sub_categories.filter((item_filter: any) => item_filter.id == e.target.value);
                        if (filter_sub_categorie.length > 0) {
                            categorie_id = filter_sub_categorie[0].parent_id;
                        }
                    }
                });
            }
            this.setState({
                categorie_id: categorie_id,
                sub_categorie_id: e.target.value,
                pages: 0,
                pageSize: 10,

            });
            setTimeout(this.getDataPaginInit.bind(this), 1000);
        } else if (e.target.name == "categorie_id") {
            this.setState({
                categorie_id: e.target.value,
                sub_categorie_id: null,
                pages: 0,
                pageSize: 10,

            });
            setTimeout(this.getDataPaginInit.bind(this), 1000);
        } else if (e.target.name == "categorie_id") {
            this.setState({
                categorie_id: e.target.value,
                sub_categorie_id: null,
                pages: 0,
                pageSize: 10,

            });
            setTimeout(this.getDataPaginInit.bind(this), 1000);
        } else if (e.target.name == "sub_categorie_id") {
            let mode_list: any = this.state.mode_list ? false : true;
            window.localStorage.setItem('ari_app_mode_list', mode_list);
            this.setState({
                mode_list: mode_list
            });
        } else if (e.target.name == "price_group") {
            this.setState({
                price_group: e.target.value,
                pages: 0,
                pageSize: 10,

            });
            setTimeout(this.getDataPaginInit.bind(this), 1000);
        } else {
            this.setState({ ...this.state, [e.target.name]: e.target.value });
        }
    }

    buttomup() {

        if (this.contentRef.current) {
            this.contentRef.current.scrollToTop();
        }

    }

    changeModeList() {
        let mode_list: any = this.state.mode_list ? false : true;
        window.localStorage.setItem('ari_app_mode_list', mode_list);
        this.setState({
            mode_list: mode_list
        });
    }

    AddToCar(product: any) {
        product['modalOpen'] = false;
        product['view_active'] = 'dashboard_pos/Products';
        this.props.addshoppingcart(product);
    }

    handleRefresh(event: any) {
        this.setState({
            pages: 0,
            pageSize: 10,
        });
        setTimeout(() => {
            event.detail.complete();
        }, 2000);
        setTimeout(this.getDataPaginInit.bind(this), 1000);
    }

    changebusinessLocations(e: any) {
        this.props.removedshoppingcartall(e.value);
        this.setState({
            pages: 0,
            pageSize: 10,
            pos_location_id: e.value
        });

        // setTimeout(this.getDataPaginInit.bind(this), 1000);
    }

    render() {
        const { pos_location_id, categorie_id, products, searchText, contact, mode_list, data_default, price_group, data_module } = this.state;
        let data_render_products = [];
        if (products && products.length > 0) {
            data_render_products = [];
            data_render_products = products.map((val: any, key: any) =>
                mode_list ? this.render_products_list(val, key) : this.render_products(val, key)
            );
        };
        let data_render_categories = [];
        if (data_default && data_default.categories) {
            data_render_categories = [];
            data_render_categories = data_default.categories.map((val: any, key: any) =>
                this.render_categories(val, key)
            );
        };

        return (
            <>
                <IonMenu contentId="main-content">
                    <IonHeader>
                        <IonToolbar>
                            <IonTitle>Categorias</IonTitle>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent className="ion-padding">
                        <IonRow>
                            {data_render_categories}
                        </IonRow>
                    </IonContent>
                </IonMenu>
                <IonPage id="main-content">
                    <IonHeader>
                        <IonToolbar color="primary">
                            <IonTitle>Productos </IonTitle>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent fullscreen scrollEvents={true} ref={this.contentRef}>
                        <IonRefresher slot="fixed" onIonRefresh={(e) => this.handleRefresh(e)}>
                            <IonRefresherContent></IonRefresherContent>
                        </IonRefresher>
                        <IonRow>
                            <IonCol size='12' col-12>
                                <label>Sucursal: </label>
                                {
                                    data_default && data_default.businessLocations && data_default.businessLocations.length > 0 ?
                                        <Select
                                            onChange={
                                                (e: any) => this.changebusinessLocations(e)
                                            }
                                            placeholder="Ubicación"
                                            name='pos_location_id'
                                            menuPortalTarget={document.querySelector('body')}
                                            isSearchable={false}
                                            options={[
                                                ...(data_default && data_default.businessLocations
                                                    .filter((item: any) => item.id != null)
                                                    .map((value: any) => ({ label: value.name, value: value.id }))
                                                )
                                            ]}
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                            }}
                                            defaultValue={pos_location_id ?
                                                data_default.businessLocations && data_default.businessLocations.length > 0 ?
                                                    { label: data_default.businessLocations.filter((item: any) => item.id == pos_location_id)[0].name, value: data_default.businessLocations.filter((item: any) => item.id == pos_location_id)[0].id }
                                                    : { label: 'Seleccione', value: null }
                                                : { label: 'Seleccione', value: null }
                                            }
                                        /> : null
                                }
                            </IonCol>
                            <IonCol col-12 size='12' style={{ textAlign: "center" }}>
                                <strong>Cliente: </strong>{contact && contact.name ? (contact.supplier_business_name ?? '') + " / " + (contact.name ?? '') : '-'}
                            </IonCol>

                            <IonCol col-12 size='12' style={{ textAlign: "center" }}>
                                <div style={{ display: "none" }}>
                                    <IonSearchbar onIonChange={e => this.setSearchText(e)} value={searchText}></IonSearchbar>
                                </div>
                            </IonCol>
                            <IonCol col-10 size='10' class='divflex'>
                                <IonIcon icon={search} className='iconseach'></IonIcon>
                                <DebounceInput
                                    className='btn_search'
                                    placeholder={'Buscar Producto Por Nombre/SKU'}
                                    minLength={2}
                                    debounceTimeout={2000}
                                    value={searchText}
                                    onChange={e => this.setSearchText(e)} />
                            </IonCol>
                            <IonCol col-2 size='2'>
                                <IonMenuToggle>
                                    <IonButton>
                                        <IonIcon icon={funnel}></IonIcon>
                                    </IonButton>
                                </IonMenuToggle>
                            </IonCol>
                            <IonCol col-10 size='10'>
                                {
                                    data_default && data_default.price_groups_array && data_default.price_groups_array.length > 0 ?
                                        <Select
                                            onChange={(e: any) => this.changeDataState({ target: { name: 'price_group', value: e.value } })}
                                            placeholder="Grupos de Precios"
                                            name='price_group'
                                            menuPortalTarget={document.querySelector('body')}
                                            isSearchable={false}
                                            options={
                                                data_default.price_groups_array && data_default.price_groups_array.map((option: any) => (
                                                    { label: option.name, value: option.id }
                                                ))
                                            }
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                            }}
                                            defaultValue={price_group ?
                                                data_default.price_groups_array && data_default.price_groups_array.length > 0 ?
                                                    { label: data_default.price_groups_array.filter((item: any) => item.id == price_group)[0].name, value: data_default.price_groups_array.filter((item: any) => item.id == price_group)[0].id }
                                                    : null
                                                : null
                                            }
                                        /> : null
                                }
                            </IonCol>
                            <IonCol col-2 size='2' style={{ textAlign: "center" }}>
                                <IonButton color='primary' onClick={() => this.changeModeList()}>
                                    <IonIcon icon={mode_list ? albumsOutline : list}></IonIcon>
                                </IonButton>
                            </IonCol>
                        </IonRow>
                        <IonGrid>
                            <IonRow align-items-center>
                                {data_render_products}
                            </IonRow>
                        </IonGrid>
                        <IonInfiniteScroll threshold="50px" ref={this.ionInfiniteScrollRefData}
                            onIonInfinite={(event) => {
                                this.getDataPaginInit();
                            }}
                        >
                            <IonInfiniteScrollContent loadingText="Cargando mas datos..." loadingSpinner="bubbles"></IonInfiniteScrollContent>
                        </IonInfiniteScroll>
                        <IonFab style={{ marginBottom: "0px" }} slot="fixed" vertical="bottom" horizontal="end">
                            <IonFabButton>
                                <IonFabButton onClick={e => this.buttomup()}><IonIcon icon={arrowUp}></IonIcon></IonFabButton>
                            </IonFabButton>
                        </IonFab>
                    </IonContent>
                </IonPage >
            </>
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data,
        _get: PropTypes.func.isRequired,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        addshoppingcart: (product: any) => dispatch(PosActions.addshoppingcart(product)),
        setData_: (data: any, name: string) => dispatch(PosActions.setData(data, name)),

        get_: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),
        removedshoppingcartall: (value: any) => dispatch(PosActions.removedshoppingcartall(value)),

    }
};

export default withIonLifeCycle(connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Products));

